import {Enum} from './enun';

export const settingsViewMode = new Enum({
  grid: 0,
  list: 1
});
